import {
  getFirestore,
  collection,
  Timestamp,
  or,
  and,
  writeBatch,
  DocumentSnapshot,
  onSnapshot,
  setDoc,
} from "firebase/firestore"
import { query, DocumentData, updateDoc, arrayUnion } from "firebase/firestore"
import { orderBy, QueryDocumentSnapshot, doc } from "firebase/firestore"
import { startAfter, limit, getDocs, where, getDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { getUser, Inspector, getAuthHeader } from "@/services/auth"
import { DateTime } from "luxon"
import { InspectionType, PaginatedInspections } from "@/types/inspection"
export type { InspectionType, PaginatedInspections }
import localforage from "localforage"
import Sugar from "sugar"
import { getPreferences } from "@/services/Preferences"
import Time from "@/utils/time"
import dexie, {
  getAllRemoteMedia,
  getComments,
  getFourPoint,
  getMedia,
  getReInspections,
  getSections,
  getSummaries,
  ensureDb,
  MediaType,
  ReportComment,
  ReportItem,
  ReportSection,
} from "@/database"

type ChangeType =
  | "comment"
  | "summary"
  | "4point"
  | "windmit"
  | "wdir"
  | "wdo"
  | "reinspection"

export type ReportPayload = {
  api:
  | "report"
  | "report-summary"
  | "4point"
  | "windmit"
  | "wdo"
  | "wdir"
  | "reinspection"
  report: any
}
type QueryByType = {
  inspections?: InspectionType[]
  inspection?: InspectionType
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData> | null
}
export function getActiveInspection() {
  if (typeof window !== "undefined") {
    const id = localStorage.getItem("activeInspection")
    if (id === "undefined" || id === "null") return ""
    return id || ""
  }
  return ""
}
export async function getUpcoming(
  lastVisible: QueryDocumentSnapshot | null = null,
) {
  const user = await getUser()
  const documents = collection(getFirestore(), "inspections")
  if (!user) throw new Error("user not logged in")

  let q = query(
    documents,
    where("uid", "==", user.uid),
    where("status", "in", ["pending", "accept"]),
    orderBy("date.started", "desc"),
    limit(10),
  )
  if (lastVisible) {
    q = query(
      documents,
      where("uid", "==", user?.uid),
      where("status", "in", ["pending", "accept"]),
      orderBy("date.started", "desc"),
      startAfter(lastVisible),
      limit(10),
    )
  }

  const snapshots = await getDocs(q)
  await ensureDb()
  if (snapshots.empty) return { inspections: [], lastVisible: null }

  const inspections = snapshots.docs.map(snapshot => {
    let data = snapshot.data()
    //code block  fixes old start date/time formatting
    if (typeof data.date.started === "string") {
      const started = Timestamp.fromDate(new Date(data.date.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.started"]: started,
      })
    }
    //code block  fixes old end date/time formatting
    if (typeof data.date.ended === "string") {
      const ended = Timestamp.fromDate(new Date(data.date.ended))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.ended"]: ended,
      })
    }
    //code block fixes old started date/time formatting
    if (typeof data.started === "string") {
      const started = Timestamp.fromDate(new Date(data.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), { started })
    }
    return { id: snapshot.id, ...data } as InspectionType
  })
  await dexie.table("inspections").bulkPut(inspections)
  const newLastVisible = snapshots.docs[snapshots.docs.length - 1] || null

  return { inspections, lastVisible: newLastVisible }
}
export async function getCompleted(
  lastVisible: QueryDocumentSnapshot | null = null,
) {
  const user = await getUser()
  const documents = collection(getFirestore(), "inspections")
  if (!user) throw new Error("user not logged in")

  let q = query(
    documents,
    where("uid", "==", user.uid),
    where("status", "==", "completed"),
    orderBy("date.started", "desc"),
    limit(10),
  )
  if (lastVisible) {
    q = query(
      documents,
      where("uid", "==", user?.uid),
      where("status", "==", "completed"),
      orderBy("date.started", "desc"),
      startAfter(lastVisible),
      limit(10),
    )
  }

  const snapshots = await getDocs(q)
  await ensureDb()
  if (snapshots.empty) return { inspections: [], lastVisible: null }

  const inspections = snapshots.docs.map(snapshot => {
    let data = snapshot.data()
    //code block  fixes old start date/time formatting
    if (typeof data.date.started === "string") {
      const started = Timestamp.fromDate(new Date(data.date.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.started"]: started,
      })
    }
    //code block  fixes old end date/time formatting
    if (typeof data.date.ended === "string") {
      const ended = Timestamp.fromDate(new Date(data.date.ended))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.ended"]: ended,
      })
    }
    //code block fixes old started date/time formatting
    if (typeof data.started === "string") {
      const started = Timestamp.fromDate(new Date(data.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), { started })
    }
    return { id: snapshot.id, ...data } as InspectionType
  })
  await dexie.table("inspections").bulkPut(inspections)
  const newLastVisible = snapshots.docs[snapshots.docs.length - 1] || null

  return { inspections, lastVisible: newLastVisible }
}
export async function getInspections(
  lastVisible: QueryDocumentSnapshot | null = null,
  offset: number = 0,
): Promise<PaginatedInspections> {
  const user = await getUser()
  const documents = collection(getFirestore(), "inspections")
  const { offline_mode } = await getPreferences()

  if (!user) throw new Error("user not logged in")
  const { uid } = user
  const status = ["pending", "accept", "completed"]
  if (offline_mode) {
    // if (offset) {
    //   const inspections = await dexie
    //     .table("inspections")
    //     .where({ uid })
    //     .and(({ status }) => status.includes(status))
    //     .offset(offset)
    //     .limit(10)
    //     .reverse()
    //     .sortBy("date.started")
    //   if (!inspections.length) return { inspections: [], lastVisible: null }
    //   return { inspections, lastVisible: null, offset: (offset += 10) }
    // }
    // const inspections = await dexie
    //   .table("inspections")
    //   .where({ uid })
    //   .and(({ status }) => status.includes(status))
    //   .limit(10)
    //   .reverse()
    //   .sortBy("date.started")
    // if (!inspections.length) return { inspections: [], lastVisible: null }
    // return { inspections, lastVisible: null, offset: (offset += 10) }
  }
  let q = query(
    documents,
    where("uid", "==", user.uid),
    where("status", "in", status),
    orderBy("date.started", "desc"),
    limit(10),
  )

  if (lastVisible) {
    q = query(
      documents,
      where("uid", "==", uid),
      where("status", "in", status),
      orderBy("date.started", "desc"),
      startAfter(lastVisible),
      limit(10),
    )
  }
  const snapshots = await getDocs(q)
  if (snapshots.empty) return { inspections: [], lastVisible: null }

  const inspections = snapshots.docs.map(snapshot => {
    let data = snapshot.data()
    if (typeof data.date.started === "string") {
      const started = Timestamp.fromDate(new Date(data.date.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.started"]: started,
      })
    }
    if (typeof data.date.ended === "string") {
      const ended = Timestamp.fromDate(new Date(data.date.ended))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.ended"]: ended,
      })
    }
    if (typeof data.started === "string") {
      const started = Timestamp.fromDate(new Date(data.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), { started })
    }

    return { id: snapshot.id, ...data } as InspectionType
  })
  await dexie.table("inspections").bulkPut(inspections)
  const newLastVisible = snapshots.docs[snapshots.docs.length - 1] || null

  return { inspections, lastVisible: newLastVisible }
}
export async function getInspection(
  id: string = getActiveInspection(),
): Promise<InspectionType | null> {
  if (!id || id === "undefined" || id === "null") return null
  const document = doc(getFirestore(), `inspections/${id}`)
  let timeout: any
  const timeoutPromise = new Promise((res, rej) => {
    timeout = setTimeout(async () => {
      clearTimeout(timeout)
      //get inspection from dexie if firestore is taking too long
      const inspection = await dexie.table("inspections").get(id)

      if (inspection) return res(inspection)
      rej(new Error("Inspection not found in local database"))
    }, 3000)
  })

  const snapshot = (await Promise.any([getDoc(document), timeoutPromise])) as
    | DocumentSnapshot
    | InspectionType


  clearTimeout(timeout)
  if ("uid" in snapshot) {
    //if inspection was fetched from dexie
    return snapshot
  }

  if (!snapshot.exists()) {
    await ensureDb()
    const local = await dexie.table("inspections").get(id)
    if (local) return local
    return null
  }
  const inspection = { id: snapshot.id, ...snapshot.data() } as InspectionType
  await dexie.table("inspections").put(inspection)
  return inspection

}
export async function queryByStatus(
  status: string[],
  lastVisible: QueryDocumentSnapshot | null = null,
  order: "desc" | "asc" = "desc",
) {
  const user = await getUser()
  const documents = collection(getFirestore(), "inspections")
  if (!user) throw new Error("user not logged in")

  let q = query(
    documents,
    and(
      or(
        where("uid", "==", user.uid),
        where("contributors", "array-contains", user.uid),
      ),
      where("status", "in", status),
    ),
    orderBy("date.started", order),

    limit(10),
  )

  if (lastVisible) {
    q = query(
      documents,
      and(
        or(
          where("uid", "==", user.uid),
          where("contributors", "array-contains", user.uid),
        ),
        where("status", "in", status),
      ),
      orderBy("date.started", order),

      startAfter(lastVisible),
      limit(10),
    )
  }

  const snapshots = await getDocs(q)
  if (snapshots.empty) return { inspections: [], lastVisible: null }

  const inspections = snapshots.docs.map(snapshot => {
    let data = snapshot.data()
    //code block  fixes old start date/time formatting
    if (typeof data.date.started === "string") {
      const started = Timestamp.fromDate(new Date(data.date.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.started"]: started,
      })
    }
    //code block  fixes old end date/time formatting
    if (typeof data.date.ended === "string") {
      const ended = Timestamp.fromDate(new Date(data.date.ended))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), {
        ["date.ended"]: ended,
      })
    }
    //code block fixes old started date/time formatting
    if (typeof data.started === "string") {
      const started = Timestamp.fromDate(new Date(data.started))
      updateDoc(doc(getFirestore(), `inspections/${snapshot.id}`), { started })
    }
    return { id: snapshot.id, ...data } as InspectionType
  })

  const newLastVisible = snapshots.docs[snapshots.docs.length - 1] || null

  return { inspections, lastVisible: newLastVisible }
}
/**
 * The has changed function keeps track of changes made during the course of the inpsection
 * and resets when a inspection is completed.
 */
export async function reportHasChanged(
  change?: ChangeType,
): Promise<ChangeType[]> {
  const id = getActiveInspection()
  const key = `report-changes-${id}`

  if (change) {
    // Save to Firestore
    const document = doc(getFirestore(), `inspections/${id}`)
    try {
      await updateDoc(document, { changes: arrayUnion(change) })
    } catch (error) {
      console.error("Failed to sync change to Firestore:", error)
    }

    // Also save to localforage for offline support/immediate feedback
    const changes = (await localforage.getItem(key)) as ChangeType[] || []
    if (!changes.includes(change)) {
      const newChanges = [...changes, change]
      await localforage.setItem(key, newChanges)
      return newChanges
    }
    return changes
  }

  // If no change passed, we are querying for the current list of changes
  const { offline_mode } = await getPreferences()
  if (!offline_mode) {
    try {
      const document = doc(getFirestore(), `inspections/${id}`)
      const snapshot = await getDoc(document)
      if (snapshot.exists()) {
        const data = snapshot.data()
        const firestoreChanges = (data.changes || []) as ChangeType[]
        // Sync localforage with Firestore data
        await localforage.setItem(key, firestoreChanges)
        return firestoreChanges
      }
    } catch (error) {
      console.error("Failed to fetch changes from Firestore:", error)
    }
  }

  const localChanges = (await localforage.getItem(key)) as ChangeType[]
  return localChanges || []
}
export async function clearReportChanges() {
  const id = getActiveInspection()
  const key = `report-changes-${id}`

  const { offline_mode } = await getPreferences()
  if (!offline_mode) {
    try {
      const document = doc(getFirestore(), `inspections/${id}`)
      await updateDoc(document, { changes: [] })
    } catch (error) {
      console.error("Failed to clear changes in Firestore:", error)
    }
  }

  await localforage.removeItem(key)
  return true
}
export function setActiveInspection(id: string) {
  if (typeof window !== "undefined" && id && id !== "undefined" && id !== "null") {
    localStorage.setItem("activeInspection", id)
  }
}
export async function updateInspection(id: string, update: {}) {
  const document = doc(getFirestore(), `inspections/${id}`)
  await ensureDb()
  await dexie.table("inspections").update(id, update)
  updateDoc(document, update).catch(console.error)
}
export async function byDate(
  date: Date,
  lastVisible: QueryDocumentSnapshot | null = null,
  order: "desc" | "asc" = "desc",
) {
  const user = await getUser()
  const documents = collection(getFirestore(), "inspections")
  const start = DateTime.fromJSDate(date).set({ hour: 7, minute: 0 })
  const end = DateTime.fromJSDate(date).set({ hour: 23, minute: 59 })

  if (!user) throw new Error("user not logged in")

  let q = query(
    documents,
    and(
      or(
        where("uid", "==", user.uid),
        where("contributors", "array-contains", user.uid),
      ),
      where("date.started", ">=", start.toJSDate()),
      where("date.started", "<", end.toJSDate()),
    ),
    orderBy("date.started", order),
    limit(10),
  )
  // let q = query(
  //   documents,
  //   where("uid", "==", user.uid),
  //   where("date.started", ">=", start.toJSDate()),
  //   where("date.started", "<", end.toJSDate()),
  //   where("contributors", "array-contains", user.uid),
  //   orderBy("date.started", order),
  //   limit(10),
  // )
  if (lastVisible) {
    q = query(
      documents,
      and(
        or(
          where("uid", "==", user.uid),
          where("contributors", "array-contains", user.uid),
        ),
        where("date.started", ">=", start.toJSDate()),
        where("date.started", "<", end.toJSDate()),
      ),
      orderBy("date.started", order),
      startAfter(lastVisible),
      limit(10),
    )
  }
  const snapshots = await getDocs(q)
  if (snapshots.empty) return { inspections: [], lastVisible: null }
  const inspections = snapshots.docs.map(snapshot => {
    return {
      ...snapshot.data(),
      id: snapshot.id,
    } as InspectionType
  })
  await dexie.table("inspections").bulkPut(inspections)
  const newLastVisible = snapshots.docs[snapshots.docs.length - 1] || null
  return { inspections, lastVisible: newLastVisible }
}
export async function queryBy(
  term: string,
  lastVisible: QueryDocumentSnapshot | null = null,
  order: "desc" | "asc" = "desc",
): Promise<QueryByType | null> {
  const result = {}
  if (isNaN(parseInt(term))) {
    const date = Sugar.Date.create(term)
    //if true then term is not a date
    if (isNaN(date.getSeconds())) return null

    return await byDate(date, lastVisible, order)
  }
  if (term.length < 3) return null
  const inspection = await getInspection(term)
  if (!inspection) return null
  await dexie.table("inspections").put(inspection)
  return { inspection }
}
export function useGetInspection(id: string = getActiveInspection()) {
  const [data, setData] = useState<InspectionType | null>()

  useEffect(() => {

    getInspection(id).then(data => setData(data))
  }, [id])

  return data
}
export function useGetInspections() {
  const [data, setData] = useState<PaginatedInspections>({
    inspections: null,
    lastVisible: null,
  })

  useEffect(() => {
    //guard against continious calls
    if (data.inspections) return

    getInspections().then(data => {
      setData(data)
    })
  }, [data])
  return data
}
export function useGetUpcoming() {
  const [data, setData] = useState<PaginatedInspections>({
    inspections: null,
    lastVisible: null,
  })

  useEffect(() => {
    //guard against continious calls
    if (data.inspections) return

    getUpcoming().then(data => {
      setData(data)
    })
  }, [data])
  return data
}
export function useGetCompleted() {
  const [data, setData] = useState<PaginatedInspections>({
    inspections: null,
    lastVisible: null,
  })

  useEffect(() => {
    //guard against continious calls
    if (data.inspections) return

    getCompleted().then(data => {
      setData(data)
    })
  }, [data])
  return data
}
export function useQueryBy(term: string) {
  const [data, setData] = useState<PaginatedInspections>({
    inspections: null,
    lastVisible: null,
  })

  useEffect(() => {
    //guard against continious calls
    if (data.inspections || !term) return
    if (isNaN(parseInt(term))) {
      const date = Sugar.Date.create(term)
      if (isNaN(date.getSeconds())) {
      }

      return
    }

    // byDate(date).then(setData)
  }, [data])
  return data
}
export async function generateReport() {
  const sections = await getSections()
  const comments = await getComments()
  const media = await getAllRemoteMedia()
  let batch = writeBatch(getFirestore())
  let writeCount = 0

  const commitBatch = async () => {
    if (writeCount > 0) {
      await batch.commit()
      batch = writeBatch(getFirestore())
      writeCount = 0
    }
  }
  const reportSections: ReportSection[] = []
  const summarySection: ReportSection[] = []
  const conditionsSection: ReportSection = {
    id: "5bedb87ed9f4ad5f",
    name: "CONDITIONS",
    items: [],
    index: 0,
  }
  const conditions = sections.shift()

  if (comments) {
    for (let s = 0; s < sections.length; s++) {
      const reportItems: ReportItem[] = []
      const summaryItems: ReportItem[] = []
      if (comments[sections[s].id]) {
        const { items } = sections[s]
        for (let i = 0; i < items.length; i++) {
          const reportComments: ReportComment[] = []
          const summaryComments: ReportComment[] = []
          if (comments[sections[s].id][items[i].id]) {
            const fields = items[i].comments

            for (let c = 0; c < fields.length; c++) {
              if (comments[sections[s].id][items[i].id][fields[c].id]) {
                const comment =
                  comments[sections[s].id][items[i].id][fields[c].id]

                const document = doc(getFirestore(), `comments/${comment.id}`)
                const mediaReferences: string[] = []

                const uploadedMedia: MediaType[] = []
                media.map(media => {
                  if (media.dataURI) {
                    delete media.dataURI
                  }
                  if (media.uploaded && media.path === comment.path) {
                    mediaReferences.push(media.name)
                    uploadedMedia.push(media)
                  }

                  return media
                })

                if (!comment.media) comment.media = []

                batch.set(
                  document,
                  {
                    media: Sugar.Array([
                      ...comment.media,
                      ...mediaReferences,
                    ]).unique().raw,
                    inspectionID: comment.inspectionID || getActiveInspection(),
                  },
                  { merge: true },
                )
                writeCount++
                if (writeCount >= 450) await commitBatch()
                const summaryMedia = uploadedMedia.filter(
                  ({ summary }) => summary,
                )

                reportComments.push({
                  ...comment,
                  media: uploadedMedia,
                  name: fields[c].name,
                  index: fields[c].index,
                })

                if (comment.summary) {
                  summaryComments.push({
                    ...comment,
                    text: comment.summaryText,
                    media: summaryMedia,
                    name: fields[c].name,
                    index: fields[c].index,
                  })
                }
              }
            }
          }
          if (reportComments.length > 0) {
            reportItems.push({
              id: items[i].id,
              name: items[i].name,
              comments: reportComments,
            })
          }
          if (summaryComments.length > 0) {
            summaryItems.push({
              id: items[i].id,
              name: items[i].name,
              comments: summaryComments,
            })
          }
        }
      }
      if (reportItems.length > 0) {
        reportSections.push({
          id: sections[s].id,
          name: sections[s].name,
          items: reportItems,
          index: sections[s].index,
        })
      }
      if (summaryItems.length > 0) {
        summarySection.push({
          id: sections[s].id,
          name: sections[s].name,
          items: summaryItems,
          index: sections[s].index,
        })
      }
    }

    if (conditions) {
      const reportItems: ReportItem[] = []

      if (comments[conditions.id]) {
        for (let i = 0; i < conditions.items.length; i++) {
          const item = conditions.items[i]

          const reportComments: ReportComment[] = []

          for (let c = 0; c < item.comments.length; c++) {
            const field = item.comments[c]
            if (!comments[conditions.id]) break
            if (!comments[conditions.id][item.id]) break
            if (!comments[conditions.id][item.id][field.id]) break

            if (comments[conditions.id][item.id][field.id]) {
              const comment = comments[conditions.id][item.id][field.id]

              const document = doc(getFirestore(), `comments/${comment.id}`)
              const mediaReferences: string[] = []

              const uploadedMedia: MediaType[] = []
              media.map(media => {
                if (media.dataURI) {
                  delete media.dataURI
                }
                if (media.uploaded && media.path === comment.path) {
                  mediaReferences.push(media.name)
                  uploadedMedia.push(media)
                }

                return media
              })
              if (!comment.media) comment.media = []

              batch.set(
                document,
                {
                  media: Sugar.Array([
                    ...comment.media,
                    ...mediaReferences,
                  ]).unique().raw,
                  inspectionID: comment.inspectionID || getActiveInspection(),
                },
                { merge: true },
              )
              writeCount++
              if (writeCount >= 450) await commitBatch()

              reportComments.push({
                ...comment,
                media: uploadedMedia,
                name: field.name,
                index: field.index,
              })
            }
          }

          if (reportComments.length > 0) {
            reportItems.push({
              id: item.id,
              name: item.name,
              comments: reportComments,
            })
          }
        }

        if (reportItems.length > 0) {
          conditionsSection.items = reportItems
        }
      }
    }
  }

  await commitBatch()
  return {
    sections: reportSections,
    sectionSummary: summarySection,
    conditions: conditionsSection,
  }
}
export async function generateReportSummary() {
  const sections = await getSections()
  const comments = await getSummaries()
  const media = await getAllRemoteMedia()
  const summarySection: ReportSection[] = []

  if (comments) {
    for (let s = 0; s < sections.length; s++) {
      const summaryItems: ReportItem[] = []
      if (comments[sections[s].id]) {
        const { items } = sections[s]

        for (let i = 0; i < items.length; i++) {
          const summaryComments: ReportComment[] = []
          if (comments[sections[s].id][items[i].id]) {
            const fields = items[i].comments

            for (let c = 0; c < fields.length; c++) {
              if (comments[sections[s].id][items[i].id][fields[c].id]) {
                const comment =
                  comments[sections[s].id][items[i].id][fields[c].id]

                const summaryMedia = media.filter(({ summary, path }) => {
                  if (summary && comment.path === path) return true
                })

                if (comment.summary) {
                  summaryComments.push({
                    ...comment,
                    text: comment.summaryText,
                    media: summaryMedia,
                    name: fields[c].name,
                    index: fields[c].index,
                  })
                }
              }
            }
          }

          if (summaryComments.length > 0) {
            summaryItems.push({
              id: items[i].id,
              name: items[i].name,
              comments: summaryComments,
            })
          }
        }
      }

      if (summaryItems.length > 0) {
        summarySection.push({
          id: sections[s].id,
          name: sections[s].name,
          items: summaryItems,
          index: sections[s].index,
        })
      }
    }
  }

  return summarySection
}
export async function generateReinspectionReport() {
  const sections = await getSections()
  const comments = await getReInspections()
  // const media = await getAllRemoteMedia()
  const reportSections: ReportSection[] = []

  if (comments) {
    for (let s = 0; s < sections.length; s++) {
      const reportItems: ReportItem[] = []

      if (comments[sections[s].id]) {
        const { items } = sections[s]

        for (let i = 0; i < items.length; i++) {
          const reportComments: ReportComment[] = []

          if (comments[sections[s].id][items[i].id]) {
            const fields = items[i].comments

            for (let c = 0; c < fields.length; c++) {
              if (comments[sections[s].id][items[i].id][fields[c].id]) {
                const comment =
                  comments[sections[s].id][items[i].id][fields[c].id]

                let media = []
                for (let m = 0; m < comment.media.length; m++) {
                  const image = await getMedia(comment.media[m])
                  if (!image) continue
                  if (image?.dataURI) delete image.dataURI
                  media.push(image)
                }

                reportComments.push({
                  ...comment,
                  media,
                  name: fields[c].name,
                  index: fields[c].index,
                })
              }
            }
          }
          if (reportComments.length > 0) {
            reportItems.push({
              id: items[i].id,
              name: items[i].name,
              comments: reportComments,
            })
          }
        }
      }
      if (reportItems.length > 0) {
        reportSections.push({
          id: sections[s].id,
          name: sections[s].name,
          items: reportItems,
          index: sections[s].index,
        })
      }
    }
  }

  return { sections: reportSections }
}
export async function generateFourPoint() {
  const {
    electrical,
    hvac,
    dwelling,
    plumbing,
    roof,
    additionalComments,
    yearBuilt,
  } = await getFourPoint()
  const fetchImages = async (images: string[]) => {
    let results = []
    for (let i = 0; i < images.length; i++) {
      const image = await getMedia(images[i])
      if (!image) continue
      if (image?.dataURI) delete image.dataURI
      results.push(image)
    }
    return results
  }
  if (electrical?.images) {
    let images = await fetchImages(electrical?.images as string[])
    electrical.images = images
  }
  if (hvac?.images) {
    let images = await fetchImages(hvac.images as string[])
    hvac.images = images
  }
  if (dwelling?.images) {
    let images = await fetchImages(dwelling.images as string[])
    dwelling.images = images
  }
  if (plumbing?.images) {
    let images = await fetchImages(plumbing.images as string[])
    plumbing.images = images
  }
  if (roof?.images) {
    let images = await fetchImages(roof.images as string[])
    roof.images = images
  }

  return {
    electrical,
    hvac,
    dwelling,
    plumbing,
    roof,
    additionalComments,
    yearBuilt,
  }
}
export async function generateWdir() {
  const id = getActiveInspection()
  const document = doc(getFirestore(), `wdirs/${id}`)
  const snapshot = await getDoc(document)

  if (!snapshot.exists()) return {}
  const data = snapshot.data()

  const toDate = (val: any) => {
    if (!val) return new Date()
    return new Date(Time.toMillis(val))
  }

  if (data.modified) {
    data.modified = toDate(data.modified)
  }
  let date = data.date
  if (date) {
    date = toDate(date)
  } else if (!date) {
    // Fallback if date is missing
    const inspection = await getInspection(id)
    date = toDate(inspection?.date?.started)
  }
  const wdir = { ...data, date }
  return wdir
}
export async function generateWindmit() {
  const id = getActiveInspection()
  const document = doc(getFirestore(), `windmits/${id}`)
  const snapshot = await getDoc(document)

  if (!snapshot.exists()) return {}
  const windMit = snapshot.data()

  const {
    roofDeckAttachment,
    roofWallAttachment,
    roofGeometry,
    secondaryWaterResistance,
    gazedOpening,
    nonGazedOpening,
    openProtection,
  } = windMit
  const fetchImages = async (images: string[]) => {
    let results = []

    for (let i = 0; i < images.length; i++) {
      const image = await getMedia(images[i])
      if (!image) continue
      if (image.dataURI) delete image.dataURI
      results.push(image)
    }

    return results
  }
  if (roofDeckAttachment?.images) {
    let images = await fetchImages(roofDeckAttachment?.images as string[])
    windMit.roofDeckAttachment.images = images
  }
  if (roofWallAttachment?.images) {
    let images = await fetchImages(roofWallAttachment?.images as string[])
    windMit.roofWallAttachment.images = images
  }
  if (roofGeometry?.images) {
    let images = await fetchImages(roofGeometry?.images as string[])
    windMit.roofGeometry.images = images
  }
  if (secondaryWaterResistance?.images) {
    let images = await fetchImages(secondaryWaterResistance?.images as string[])
    windMit.secondaryWaterResistance.images = images
  }
  if (gazedOpening?.images) {
    let images = await fetchImages(gazedOpening?.images as string[])
    windMit.gazedOpening.images = images
  }
  if (nonGazedOpening?.images) {
    let images = await fetchImages(nonGazedOpening?.images as string[])
    windMit.nonGazedOpening.images = images
  }
  if (openProtection?.images) {
    let images = await fetchImages(openProtection?.images as string[])
    windMit.openProtection.images = images
  }
  return windMit
}
export async function generateWdo() {
  const id = getActiveInspection()
  const document = doc(getFirestore(), `wdo/${id}`)
  const snapshot = await getDoc(document)

  const fetchImages = async (images: string[]) => {
    let results = []
    for (let i = 0; i < images.length; i++) {
      const image = await getMedia(images[i])
      if (!image) continue
      if (image?.dataURI) delete image.dataURI
      results.push(image)
    }
    return results
  }
  if (!snapshot.exists()) return {}
  const wdo = snapshot.data()

  if (wdo.images) {
    let images = await fetchImages(wdo.images)
    wdo.images = images
  }

  return wdo
}
export async function submitReport(
  { api, report }: ReportPayload,
  inspection: InspectionType,
  inspector: Inspector,
) {
  try {
    await ensureDb()
    if (!inspection)
      throw new Error(`Inspection ${getActiveInspection()} not found.`)
    const data = {
      inspector,
      inspection: {
        ...inspection,
        date: {
          started: new Date(Time.toMillis(inspection.date.started)),
          ended: new Date(Time.toMillis(inspection.date.ended)),
        },
      },
      report,
    }

    // const url = `http://localhost:5001/hdmk-inspection/us-central1/api/create/${api}`

    const url = `${process.env.GATSBY_API_ENDPOINT}/create/${api}`

    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: await getAuthHeader() as HeadersInit,
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  } catch (error) { }
}
//api end point outside of developer control
export async function externalReportApi(
  options: {
    payment: string
    sms: boolean
    email: boolean
    [key: string]: any
  },
  inspection: InspectionType,
  inspector: Inspector,
) {
  if (!inspection)
    throw new Error(`Inspection ${getActiveInspection()} not found.`)
  if (!inspector) throw new Error(`Inspector not found.`)

  if (options.email) {
    const url = `${process.env.GATSBY_API_ENDPOINT}/send-email`
    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ inspection, inspector }),
        headers: await getAuthHeader() as HeadersInit,
      })
      if (!response.ok) {
        throw new Error(`Email service returned status ${response.status}`)
      }
    } catch (error) {
      throw new Error(
        `Email notification failed: ${error instanceof Error ? error.message : JSON.stringify(error)
        }`,
      )
    }
  }

  try {
    const response = await fetch(
      "https://api.hdmk.net/api/update-order-report-status",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          key: "ba167ab7f60b864976a072d53e3c41e2",
          token: `Bearer ${inspector.token}`,
          Authorization: `Bearer ${inspector.token}`,
        },

        body: JSON.stringify({
          user_master_id: inspector.uid,
          order_master_id: inspection.id,
          payment_mode: options.payment,
          to_send_notification: options.sms,
        }),
      },
    )

    if (!response.ok) {
      throw new Error(`External API returned status ${response.status}`)
    }
  } catch (error) {
    throw new Error(
      `External order status update failed: ${error instanceof Error ? error.message : JSON.stringify(error)
      }`,
    )
  }
}

export async function getInspectors(): Promise<Inspector[]> {
  try {
    const db = getFirestore()
    const col = collection(db, "inspectors")

    const snapshots = await getDocs(col)

    if (snapshots.empty) return []

    return snapshots.docs.map(snapshot => snapshot.data() as Inspector)
  } catch (err) {
    console.error("Error fetching inspectors:", err)
    return []
  }
}
export async function addContributors(
  inspection: InspectionType,
  contributors: string[],
) {
  const { id } = inspection
  const db_fire = getFirestore()
  await ensureDb()
  const document = doc(db_fire, `inspections/${id}`)

  if (!inspection.contributors) {
    await dexie.table("inspections").update(id, { contributors })
    await updateDoc(document, { contributors })
    return
  }
  await dexie
    .table("inspections")
    .where({ id })
    .modify((data: InspectionType) => {
      data.contributors?.push(...contributors)
      return
    })
  await updateDoc(document, { contributors: arrayUnion(contributors) })
  return
}
export async function addContributor(id: string, uid: string) {
  const db_fire = getFirestore()
  await ensureDb()
  const document = doc(db_fire, `inspections/${id}`)
  const inspection = await getInspection(id)

  if (!inspection) return

  if (!inspection.contributors) {
    await dexie.table("inspections").put({ ...inspection, contributors: [uid] })
    return await updateDoc(document, { contributors: arrayUnion(uid) })
  }
  await dexie
    .table("inspections")
    .put({ ...inspection, contributors: [...inspection.contributors, uid] })
  return await updateDoc(document, { contributors: arrayUnion(uid) })
}

export function isOwner(inspection: InspectionType, uid: string): boolean {
  return inspection.uid === uid
}

export function isCollaborator(
  inspection: InspectionType,
  uid: string,
): boolean {
  return inspection.contributors?.includes(uid) || false
}

export type Presence = {
  uid: string
  name: string
  lastSeen: Timestamp
  focusedPath: string | null
}

/**
 * Updates the presence of an inspector in a specific inspection.
 */
export async function updatePresence(
  inspectionId: string,
  inspector: Inspector,
  focusedPath: string | null = null,
) {
  if (!inspectionId || !inspector) return
  const db = getFirestore()
  const presenceDoc = doc(
    db,
    `inspections/${inspectionId}/presence/${inspector.uid}`,
  )
  await setDoc(presenceDoc, {
    uid: inspector.uid,
    name: `${inspector.fname} ${inspector.lname}`,
    lastSeen: Timestamp.now(),
    focusedPath,
  })
}

/**
 * Subscribes to presence changes for an inspection.
 */
export function onPresence(
  inspectionId: string,
  callback: (presence: Presence[]) => void,
) {
  const db = getFirestore()
  const presenceCollection = collection(
    db,
    `inspections/${inspectionId}/presence`,
  )

  // Only show users active in the last 2 minutes
  const twoMinutesAgo = DateTime.now().minus({ minutes: 2 }).toJSDate()
  const q = query(
    presenceCollection,
    where("lastSeen", ">=", Timestamp.fromDate(twoMinutesAgo)),
  )

  return onSnapshot(q, snapshot => {
    const presence = snapshot.docs.map(doc => doc.data() as Presence)
    callback(presence)
  })
}

